/** Card layout for tables on phones (admin pages and every side drawer). */
import { useEffect } from 'react';

/**
 * Labels every admin and drawer table cell with its column heading (data-label), so on phones the CSS can show each row as a
 * card of "Heading  value" lines instead of a table that scrolls sideways. Watches the page and all side drawers.
 */
export function useStackedTableLabels() {
  useEffect(() => {
    let raf = 0;
    const label = () => {
      raf = 0;
      document.querySelectorAll<HTMLTableElement>('.adminroot table.data, .drawer table.data').forEach((t) => {
        const heads = [...(t.tHead?.rows[0]?.cells ?? [])].map((th) => (th.textContent ?? '').trim());
        if (!heads.length) return;
        for (const tb of t.tBodies)
          for (const tr of tb.rows) {
            let col = 0;
            for (const td of tr.cells) {
              const h = td.colSpan > 1 ? '' : (heads[col] ?? '');
              if (td.dataset.label !== h) td.dataset.label = h;
              col += td.colSpan;
            }
          }
      });
    };
    const mo = new MutationObserver(() => {
      if (!raf) raf = requestAnimationFrame(label);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    label();
    return () => {
      mo.disconnect();
      cancelAnimationFrame(raf);
    };
  }, []);
}
